<template>
  <div class="content-wrapper">
    <alert
      :alertContent="alertContent"
      @alertButtonClick="closeAlertModal"
      v-if="shouldShowAlert"
    ></alert>
    <description :content="this.content" />
  </div>
</template>

<script>
import Alert from '@/components/Alert.vue'
import APIRequest from '@/utils/APIRequest'
import Description from '@/components/Description.vue'
import { Client, defaultNativeInterfaceClient } from '@/utils/NativeInterface'
import { getToken, getTokenFromCookie } from '@/utils/token'
import { redirectToTrackerURLIfNeeded } from '@/utils/adjust_redirector'
import { LanguageQueryMixin } from '@/mixins/LanguageQuery'
import { getLocationName } from '@/utils/time'
import Config from '@/config/vue.config'

const INVITE_TYPE_FROM_NOTICE = 2

export default {
  components: {
    Alert,
    Description,
  },
  mixins: [LanguageQueryMixin],
  name: 'NoticePage',
  props: {
    id: String,
  },
  data: function () {
    return {
      pageId: '',
      content: '',
      alertContent: {
        content: {
          header: '',
          body: '',
        },
        alertItems: [],
      },
      title: '',
      shouldShowAlert: false,
    }
  },
  computed: {
    token: function () {
      return getToken()
    },
  },
  watch: {
    content: function (val) {
      // ページ内のscriptタグの中身を実行する
      this.$nextTick(this.runScript)

      this.$nextTick(this.fetchInviteCount)

      // tokenがない場合に、特定のclassの要素を消去する
      // ここで直接いじるのが一番簡単なのでここで消去（本当は受け取ったhtml内で完結してる方がいいかも）
      if (this.token === undefined) {
        this.$nextTick(function () {
          ;[].slice
            .call(this.$el.querySelectorAll('.button__invite'))
            .forEach((element) => {
              element.remove()
            })
        })
      }
    },
  },
  methods: {
    async fetchNoticeHtml() {
      this.pageId = location.pathname.split('/').slice(-1)[0]
      const locationName = getLocationName()

      const response = await this.$loader.post(
        new APIRequest(
          this.$config.appGatewayServerUrl,
          '/notice_page/get',
          { id: this.pageId, locationName: locationName },
          { 'X-VLIVE-CLIENT-TYPE': 'webapp' }
        )
      )
      if (response.noticePage) {
        this.content = response.noticePage.html
        this.title = response.noticePage.title
        document.title = this.title
      }
    },
    async inviteFriend(event) {
      // ログインしてない時は早期return(そもそも呼ばれないが一応)
      if (this.token === undefined) {
        this.openAlertModal(this.$t('notLoggedIn'))
        return
      }

      const response = await this.$loader.post(
        new APIRequest(
          this.$config.appGatewayServerUrl,
          '/streamer/invite/get_link',
          {
            campaignId: event.detail.campaign_id,
            inviteType: INVITE_TYPE_FROM_NOTICE,
          },
          {
            'X-VLIVE-CLIENT-TYPE': 'webapp',
            Authorization: `Bearer ${this.token}`,
          }
        )
      )

      if (response.errorCode) {
        this.openAlertModal(response.message)
      } else {
        var nativeInterface = defaultNativeInterfaceClient()
        nativeInterface.sendEvent('invitation', 'share', response)
      }
    },
    async fetchInviteCount() {
      const nodeList = document.querySelectorAll('.invite_count')
      if (nodeList.length == 0 || this.token === undefined) {
        return
      }

      const campaignIDTotal = -1

      // 現状の仕様的に一つのページには累計を除けばID指定は一種類
      let campaignID = 0
      let returnTotal = false
      for (const node of nodeList) {
        const tmp = +node.dataset.campaignId
        if (tmp > 0) {
          campaignID = tmp
        } else if (tmp == campaignIDTotal) {
          returnTotal = true
        }
      }

      const response = await this.$loader.post(
        new APIRequest(
          this.$config.appGatewayServerUrl,
          '/streamer/invite/get_count',
          { campaignId: campaignID, returnTotal: returnTotal },
          {
            'X-VLIVE-CLIENT-TYPE': 'webapp',
            Authorization: `Bearer ${this.token}`,
          }
        )
      )

      if (response.errorCode) {
        this.openAlertModal(response.message)
      } else {
        for (const node of nodeList) {
          if (node.dataset.campaignId == campaignID) {
            node.innerHTML = response.count
          } else if (node.dataset.campaignId == campaignIDTotal) {
            node.innerHTML = response.totalCount
          }
        }
      }
    },
    /* eslint-disable */
    openProfile(event) {
      var nativeInterface = defaultNativeInterfaceClient()
      if (nativeInterface.client !== Client.native) {
        try {
          nativeInterface.sendEvent('profileView', 'show', {
            profileId: event.detail.profile_id,
          })
        } catch (e) {
          location.href = `/profile/${event.detail.profile_id}`
        }
      } else {
        location.href = `/profile/${event.detail.profile_id}`
      }
    },
    /* eslint-disable */
    openCoinShop() {
      var nativeInterface = defaultNativeInterfaceClient()
      if (nativeInterface.client !== Client.native) {
        try {
          nativeInterface.sendEvent('coinShop', 'show', {})
        } catch (e) {}
      }
    },
    /* eslint-disable */
    openGacha(event) {
      var nativeInterface = defaultNativeInterfaceClient()
      if (nativeInterface.client !== Client.native) {
        try {
          nativeInterface.sendEvent('gacha', 'show', {
            gachaId: event.detail.gacha_id,
          })
        } catch (e) {}
      }
    },
    openGame(event) {
      const nativeInterface = defaultNativeInterfaceClient()
      if (nativeInterface.client !== Client.native) {
        try {
          nativeInterface.sendEvent('liveGame', 'show', {
            gameId: event.detail.game_id,
          })
        } catch (e) {
          //
        }
      }
    },
    openAvatarShop(event) {
      const nativeInterface = defaultNativeInterfaceClient()
      if (nativeInterface.client !== Client.native) {
        try {
          nativeInterface.sendEvent('avatarShop', 'show', {
            shopGroupId: event.detail.shop_group_id,
          })
        } catch (e) {
          //
        }
      }
    },
    openChatShare(event) {
      const nativeInterface = defaultNativeInterfaceClient()
      if (nativeInterface.client !== Client.native) {
        try {
          nativeInterface.sendEvent('chatShare', 'show', {
            pageUrl: event.detail.page_url,
          })
        } catch (e) {
          //
        }
      }
    },
    openStarLiverRanking(event) {
      if (!this.isUserWebview()) {
        const path = 'star_liver_ranking'
        window.location.href = `${Config.customUrlScheme}${path}`
      } else {
        const nativeInterface = defaultNativeInterfaceClient()
        if (nativeInterface.client !== Client.native) {
          try {
            nativeInterface.sendEvent('starLiverRanking', 'show', {})
          } catch (e) {
            //
          }
        }
      }
    },
    openFreshLiverRanking(event) {
      if (!this.isUserWebview()) {
        const path = 'fresh_liver_ranking'
        window.location.href = `${Config.customUrlScheme}${path}`
      } else {
        const nativeInterface = defaultNativeInterfaceClient()
        if (nativeInterface.client !== Client.native) {
          try {
            nativeInterface.sendEvent('freshLiverRanking', 'show', {})
          } catch (e) {
            //
          }
        }
      }
    },
    openAvatarMerchCreate(event) {
      const nativeInterface = defaultNativeInterfaceClient()
      if (nativeInterface.client !== Client.native) {
        try {
          nativeInterface.sendEvent('avatarMerchCreate', 'show', {
            themeId: event.detail.theme_id,
          })
        } catch (e) {
          //
        }
      }
    },
    openPremiumDetail(event) {
      const nativeInterface = defaultNativeInterfaceClient()
      if (nativeInterface.client !== Client.native) {
        try {
          nativeInterface.sendEvent('premiumDetail', 'show', {
            productId: event.detail.product_id,
          })
        } catch (e) {
          //
        }
      }
    },
    runScript() {
      const scripts = this.$el.querySelectorAll('script')
      if (scripts.length > 0) {
        this.runSingleScript(scripts, 0)
      }
    },
    runSingleScript(nodeList, index) {
      const runNextScriptOrEnd = (nodeList, index) => {
        // 全てのscriptを置換し終わってたら、DOMContentLoadedイベントを発行する（googleフォームのurl置換処理がDOMContentLoadedに登録されているため）
        if (index >= nodeList.length - 1) {
          document.dispatchEvent(new Event('DOMContentLoaded'))
        } else {
          this.runSingleScript(nodeList, index + 1)
        }
      }

      const node = nodeList.item(index)
      const parentNode = node.parentNode
      let alternativeNode
      if (node.src === '') {
        alternativeNode = document.createElement('script')
        alternativeNode.innerHTML = node.innerHTML
        parentNode.replaceChild(alternativeNode, node)
        runNextScriptOrEnd(nodeList, index)
      } else {
        alternativeNode = document.createElement('script')
        alternativeNode.src = node.src
        alternativeNode.onload = () => runNextScriptOrEnd(nodeList, index)
        parentNode.replaceChild(alternativeNode, node)
      }
    },
    openAlertModal(message) {
      this.alertContent = {
        content: {
          header: this.$t('noticeError'),
          body: message,
        },
        alertItems: [
          {
            type: 'preffered',
            title: 'OK',
          },
        ],
      }
      this.shouldShowAlert = true
    },
    closeAlertModal() {
      this.shouldShowAlert = false
    },
    isUserWebview() {
      return getTokenFromCookie() !== undefined
    },
  },
  created() {
    redirectToTrackerURLIfNeeded()
  },
  mounted() {
    this.fetchNoticeHtml()
    window.addEventListener('inviteFriend', this.inviteFriend)
    window.addEventListener('openProfile', this.openProfile)
    window.addEventListener('openCoinShop', this.openCoinShop)
    window.addEventListener('openGacha', this.openGacha)
    window.addEventListener('openGame', this.openGame)
    window.addEventListener('openAvatarShop', this.openAvatarShop)
    window.addEventListener('openChatShare', this.openChatShare)
    window.addEventListener('openStarLiverRanking', this.openStarLiverRanking)
    window.addEventListener('openFreshLiverRanking', this.openFreshLiverRanking)
    window.addEventListener('openAvatarMerchCreate', this.openAvatarMerchCreate)
    window.addEventListener('openPremiumDetail', this.openPremiumDetail)
  },
  destroyed() {
    window.removeEventListener('inviteFriend', this.inviteFriend)
    window.removeEventListener('openProfile', this.openProfile)
    window.removeEventListener('openCoinShop', this.openCoinShop)
    window.removeEventListener('openGacha', this.openGacha)
    window.removeEventListener('openGame', this.openGame)
    window.removeEventListener('openAvatarShop', this.openAvatarShop)
    window.removeEventListener('openChatShare', this.openChatShare)
    window.removeEventListener(
      'openStarLiverRanking',
      this.openStarLiverRanking
    )
    window.removeEventListener(
      'openFreshLiverRanking',
      this.openFreshLiverRanking
    )
    window.removeEventListener(
      'openAvatarMerchCreate',
      this.openAvatarMerchCreate
    )
    window.removeEventListener('openPremiumDetail', this.openPremiumDetail)
  },
}
</script>

<style scoped>
.content-wrapper {
  padding: 0 0 var(--safe-area-inset-bottom, 0px) 0;
}

/deep/ .button__invite {
  display: block;
  margin: 0 auto 34px;
  width: 180px;
  height: 50px;
  background-color: #188dff;
  border-radius: 25px;
  border-width: 0px;
  color: white;
  font-size: 18px;
}

/deep/ .button__coinshop {
  display: block;
  margin: 0 auto 34px;
  width: 100%;
  height: 50px;
  background-color: #188dff;
  border-radius: 25px;
  border-width: 0px;
  color: white;
  font-size: 18px;
}

/deep/ .button__gacha {
  display: block;
  margin: 0 auto 34px;
  width: 100%;
  height: 50px;
  background-color: #188dff;
  border-radius: 25px;
  border-width: 0px;
  color: white;
  font-size: 18px;
}

/deep/ .open__gacha__button {
  display: block;
}

/deep/ .close__gacha__button {
  display: none;
}
</style>
